import React, { PureComponent, PropTypes } from 'react';
import _ from 'underscore';
import FormControl from '../inputs/FormControl';
import { keyCodes } from '../../util/constants';

const ID_NAME = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export default class NativeSelect extends PureComponent {
  static propTypes = {
    options: PropTypes.arrayOf(ID_NAME).isRequired,
    valueToString: PropTypes.func,
    optionToString: PropTypes.func,
    getGroup: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    clearable: PropTypes.bool
  };

  static defaultProps = {
    valueToString: ({ name }) => name,
    optionToString: ({ name }) => name,
    getGroup: null,
    placeholder: 'Select...',
    required: false,
    clearable: true
  };

  handleEscape = e => {
    const { onKeyDown, value, clearable, onChange } = this.props;
    if (onKeyDown) {
      onKeyDown(e);
    }

    if (clearable && value) {
      switch (e.keyCode) {
        case keyCodes.KEY_BACKSPACE:
        case keyCodes.KEY_DELETE:
          onChange(null);
          e.stopPropagation();
          break;
      }
    }
  };

  handleChange = ({ target: { options: optionEls } }) => {
    const { multiple, onChange, options } = this.props;

    const selected = _.chain(optionEls)
      .filter(opt => opt.selected)
      .pluck('value')
      .compact()
      .map(id => _.findWhere(options, { id }))
      .compact()
      .value();

    if (multiple) {
      onChange(selected);
    } else {
      if (selected && selected.length === 1) {
        onChange(selected[ 0 ]);
      } else {
        onChange(null);
      }
    }
  };

  render() {
    const {
      value, onChange, options, required, placeholder,
      valueToString, optionToString, getGroup, style, clearable,
      ...rest
    } = this.props;

    const renderOptions = options => _.map(options, option => {
      const selected = value && option.id === value.id;

      return (
        <option key={option.id} value={option.id}>{selected ? valueToString(option) : optionToString(option)}</option>
      );
    });

    return (
      <FormControl>
        <select
          {...rest}
          value={value ? value.id : ''}
          onKeyDown={this.handleEscape}
          style={{ ...style, ...(value ? null : { color: 'rgba(0,0,0,0.3)' }) }}
          onChange={this.handleChange}
          required={required}
          placeholder={placeholder}>
          <option key="none" value="" hidden={!clearable} disabled={!clearable}>{placeholder}</option>

          {
            getGroup ? (
                _.chain(options)
                  .groupBy(getGroup)
                  .map(
                    (groupOptions, group) => (
                      <optgroup key={group} label={group}>{renderOptions(groupOptions)}</optgroup>
                    )
                  )
                  .value()
              ) : renderOptions(options)
          }
        </select>
      </FormControl>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/inputs/NativeSelect.jsx